import { type PropsWithChildren } from 'react';

import { HeartIcon } from '@sorare/core/src/atoms/icons/HeartIcon';
import { range } from '@sorare/core/src/lib/arrays';
import type { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  task: {
    maxLineupsCount: number;
    remainingLineupsCount: number;
    pendingLineupsCount: number;
  };
  size?: keyof typeof unitMapping;
};

export const Lifes = ({ task, size = 2 }: PropsWithChildren<Props>) => {
  const { maxLineupsCount, pendingLineupsCount, remainingLineupsCount } = task;

  const getStatus = (index: number) => {
    if (index < remainingLineupsCount) {
      return 'active';
    }
    if (index < pendingLineupsCount + remainingLineupsCount) {
      return 'pending';
    }
    return 'inactive';
  };
  return (
    <>
      {range(maxLineupsCount).map(i => (
        <HeartIcon key={i} status={getStatus(i)} size={size} />
      ))}
    </>
  );
};
